// extracted by mini-css-extract-plugin
export default {"rating":"Mz-z","numberOfStars":"Nz-z","count":"Oz-z","barGraphSpacing":"Pz-z","barGraph":"Qz-z"};